/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
  Card,
  CardContent
} from "@repo/ui";
import { RefreshCcw } from "lucide-react";
import ProgressBarChart from "pages/slaDashboard/progress-bar-chart";
import PieChart from "components/pieChart";
import MultipleStackedBarChart from "../../components/multipleStackedBarCharts";
import SemiCircleRadialChart from "../../components/semiCircleRadialChart";

import { ACTIVITY_TYPES } from "utils/constant";
import {
  useGetAssignmentGroups,
  useGetCustomers,
  useGetFieldEngineers,
  useGetRegions
} from "utils/apis/lookups.api";
import {
  useGetSLADashboardOverview,
  useGetSLADashboardResponseOverview,
  useSaveDashboardFilter,
  useGetDashboardFilter,
  useGetSlaKpi,
  useGetSlaSiteNotAccessibleKpi
} from "utils/apis/sla-dashboard.api";
import SlaKpiCard from "pages/slaDashboard/SlaKpiCard";
import {
  useDashboardOptions,
  handleDashboardNavigation
} from "pages/slaDashboard/common/dashboard-selection";
import { generateDetailLink } from "../slaDashboard/common/generate-detail-link";
import OverviewFilters from "components/dashboardFilters/OverviewFilters";
import ResponseFilters from "components/dashboardFilters/ResponseFilters";

/* ---------------- Date Presets ---------------- */
const DATE_PRESETS = [
  { id: "all", name: "All" },
  { id: "today", name: "Today" },
  { id: "yesterday", name: "Yesterday" },
  { id: "thisweek", name: "This Week" },
  { id: "lastweek", name: "Last Week" },
  { id: "thismonth", name: "This Month" },
  { id: "lastmonth", name: "Last Month" },
  { id: "last6months", name: "Last 6 Months" },
  { id: "last9months", name: "Last 9 Months" },
  { id: "last12months", name: "Last 12 Months" }
];

interface FieldEngineer {
  employeeId: string;
  name: string;
  nationality: string;
  cenconId: string;
}
/* ---------------- Static Field Engineers ---------------- */
// const FIELD_ENGINEERS = [{ id: "All", name: "All" }];

export default function SLMDispatcherDashboard() {
  const navigate = useNavigate();
  const { data: assignmentGroups } = useGetAssignmentGroups();
  const { data: fieldEngineer } = useGetFieldEngineers();
  const { data: customers } = useGetCustomers();
  const { data: regions } = useGetRegions("UAE");
  const [searchParams, setSearchParams] = useSearchParams();
  const DASHBOARD_NAME = "FLM SLA Overview 1";
  const [isHydrated, setIsHydrated] = useState(false);

  const { mutate: fetchDashboardFilter, data: savedFilter } =
    useGetDashboardFilter();
  const { mutate: getSlaKpi, data: slaKpiData } = useGetSlaKpi();
  const { mutate: getSiteNotAccessibleKpi, data: siteNotAccessibleKpi } =
    useGetSlaSiteNotAccessibleKpi();
  const { mutate: saveDashboardFilter } = useSaveDashboardFilter();
  const dashboardOptions = useDashboardOptions();

  useEffect(() => {
    fetchDashboardFilter(DASHBOARD_NAME);
  }, [DASHBOARD_NAME, fetchDashboardFilter]);

  const nf = Intl.NumberFormat();
  const syncOverviewFiltersToUrl = (
    date: string | undefined,
    assignmentGroups: string[],
    fieldEngineer: string[]
  ) => {
    const params = new URLSearchParams(window.location.search);

    if (date) params.set("overviewDate", date);
    else params.delete("overviewDate");

    if (assignmentGroups.length)
      params.set("assignmentGroups", assignmentGroups.join(","));
    else params.delete("assignmentGroups");

    if (fieldEngineer.length)
      params.set("fieldEngineer", fieldEngineer.join(","));
    else params.delete("fieldEngineer");

    setSearchParams(params, { replace: true });
  };

  const syncResponseFiltersToUrl = (
    date?: string,
    customers?: string[],
    activityTypes?: string[]
  ) => {
    const params = new URLSearchParams(searchParams);

    if (date) params.set("responseDate", date);
    else params.delete("responseDate");

    if (customers?.length) params.set("customers", customers.join(","));
    else params.delete("customers");

    if (activityTypes?.length)
      params.set("activityTypes", activityTypes.join(","));
    else params.delete("activityTypes");

    setSearchParams(params, { replace: true });
  };

  const { mutate: fetchOverview, data: overview } =
    useGetSLADashboardOverview();
  const { mutate: fetchResponseOverview, data: responseOverview } =
    useGetSLADashboardResponseOverview();

  /* ---------------- Filters ---------------- */
  interface DatePreset {
    id: string;
    name: string;
  }
  interface FiltersState {
    date?: DatePreset;
    [key: string]: any;
  }

  const [overviewFilters, setOverviewFilters] = useState<FiltersState>({
    date: DATE_PRESETS[0]
  });
  const [selectedGroups, setSelectedGroups] = useState<{ name: string }[]>([]);
  const [selectedFieldEngineers, setSelectedFieldEngineers] = useState<
    FieldEngineer[]
  >([]);
  const selectedAssignmentGroupNames = selectedGroups.map((g) => g.name);
  const [selectedDashboard, setSelectedDashboard] = useState<string>(
    "SLM Dispatcher Performance Dashboard"
  );

  const [responseFilters, setResponseFilters] = useState<FiltersState>({
    date: DATE_PRESETS[0]
  });
  const [selectedCustomers, setSelectedCustomers] = useState<any[]>([]);
  const [selectedActivityTypes, setSelectedActivityTypes] = useState<any[]>([]);
  const [selectedAccounts, setSelectedAccounts] = useState<any[]>([]);
  const [selectedRegions, setSelectedRegions] = useState<any[]>([]);

  /* ---------------- Helper Functions ---------------- */
  const normalizeFieldEngineerPayload = () =>
    selectedFieldEngineers.some((f) => f.employeeId === "all")
      ? []
      : selectedFieldEngineers.map((f) => f.employeeId);

  const updateOverviewFilter = (key: string, value?: any) => {
    setOverviewFilters((prev: any) => {
      const copy = { ...prev };
      if (!value) delete copy[key];
      else copy[key] = value;
      return copy;
    });
  };

  const updateResponseFilter = (key: string, value?: any) => {
    setResponseFilters((prev: any) => {
      const copy = { ...prev };
      if (!value) delete copy[key];
      else copy[key] = value;
      return copy;
    });
  };

  const handleDashboardChange = (value: string) => {
    setSelectedDashboard(value);
    handleDashboardNavigation(value, navigate, dashboardOptions);
  };

  const handleApplyOverviewFilters = () => {
    const overviewPayload = {
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: selectedGroups.map((g) => g.name),
      fieldEngineer: normalizeFieldEngineerPayload(),
      customers: selectedAccounts.map((c) => c.customerId),
      regions: selectedRegions.map((r) => r.name)
    };

    fetchOverview(overviewPayload);

    getSlaKpi(overviewPayload);

    getSiteNotAccessibleKpi({ ...overviewPayload, isSiteNotAccessible: true });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        AssignmentGroups: selectedGroups.map((g) => g.name),
        DatePreset: overviewFilters.date?.id,
        FieldEngineer: selectedFieldEngineers.map((f) => f.employeeId),
        Accounts: selectedAccounts.map((c) => c.customerId),
        Regions: selectedRegions.map((r) => r.name),
        Customers: selectedCustomers.map((c) => c.customerId),
        ActivityTypes: selectedActivityTypes.map((a) => a.id)
      }
    });
  };
  const handleClearOverviewFilters = () => {
    setOverviewFilters({ date: DATE_PRESETS[0] });
    setSelectedGroups([]);
    setSelectedFieldEngineers([]);
    setSelectedAccounts([]);
    setSelectedRegions([]);

    fetchOverview({
      datePreset: "all",
      assignmentGroups: [],
      fieldEngineer: [],
      customers: [],
      regions: []
    });

    getSlaKpi({
      datePreset: "all",
      assignmentGroups: [],
      fieldEngineer: [],
      customers: [],
      regions: []
    });
    getSiteNotAccessibleKpi({
      datePreset: "all",
      assignmentGroups: [],
      fieldEngineer: [],
      customers: [],
      regions: [],
      isSiteNotAccessible: true
    });
    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {}
    });
  };
  const handleApplyResponseFilters = () => {
    const payload = {
      datePreset: responseFilters.date?.id ?? "all",
      customers: selectedCustomers.map((c) => c.customerId),
      activityTypes: selectedActivityTypes.map((a) => a.id)
    };

    fetchResponseOverview(payload);

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {
        Customers: selectedCustomers.map((c) => c.customerId),
        ActivityTypes: selectedActivityTypes.map((a) => a.id)
      }
    });
  };
  const handleClearResponseFilters = () => {
    setResponseFilters({ date: DATE_PRESETS[0] });
    setSelectedCustomers([]);
    setSelectedActivityTypes([]);

    fetchResponseOverview({
      datePreset: "all",
      activityTypes: [],
      customers: []
    });

    saveDashboardFilter({
      DashboardName: DASHBOARD_NAME,
      Filters: {}
    });
  };

  const handleRefresh = () => {
    const overviewPayload = {
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: selectedGroups.map((g) => g.name),
      fieldEngineer: selectedFieldEngineers.some((f) => f.employeeId === "all")
        ? []
        : selectedFieldEngineers.map((f) => f.employeeId),
      customers: selectedAccounts.map((c) => c.customerId),
      regions: selectedRegions.map((r) => r.name)
    };

    const responsePayload = {
      datePreset: responseFilters.date?.id ?? "all",
      activityTypes: selectedActivityTypes.map((a) => a.id),
      customers: selectedCustomers.map((c) => c.customerId)
    };

    fetchOverview(overviewPayload);
    fetchResponseOverview(responsePayload);

    getSlaKpi(overviewPayload);

    getSiteNotAccessibleKpi({
      ...overviewPayload,
      isSiteNotAccessible: true
    });
  };

  useEffect(() => {
    if (
      !savedFilter?.data?.filters ||
      !assignmentGroups?.data?.length ||
      !fieldEngineer?.length ||
      !customers?.data?.length ||
      !regions?.data?.length
    )
      return;

    const filters = savedFilter?.data?.filters;

    /* ---------- Overview Filters ---------- */

    if (filters?.DatePreset) {
      const matchedDate = DATE_PRESETS.find((d) => d.id === filters.DatePreset);
      if (matchedDate) {
        setOverviewFilters({ date: matchedDate });
        setResponseFilters({ date: matchedDate });
      }
    }

    if (filters?.AssignmentGroups?.length) {
      const matchedGroups = assignmentGroups?.data?.filter(
        (g: { name: string }) => filters.AssignmentGroups.includes(g.name)
      );
      setSelectedGroups(matchedGroups);
    }

    if (filters?.FieldEngineer?.length) {
      const matchedFEs = fieldEngineer.filter((f) =>
        filters.FieldEngineer.includes(f.employeeId)
      );
      setSelectedFieldEngineers(matchedFEs);
    }

    if (filters?.Accounts?.length) {
      const matchedAccounts = customers?.data?.filter((c: any) =>
        filters.Accounts.includes(c.customerId)
      );
      setSelectedAccounts(matchedAccounts);
    }

    if (filters?.Regions?.length) {
      const matchedRegions = regions?.data?.filter((r: { name: any }) =>
        filters.Regions.includes(r.name)
      );
      setSelectedRegions(matchedRegions);
    }

    /* ---------- Response Filters ---------- */
    if (filters?.Customers?.length) {
      const matchedCustomers = customers?.data?.filter((c: any) =>
        filters.Customers.includes(c.customerId)
      );
      setSelectedCustomers(matchedCustomers);
    }

    if (filters?.ActivityTypes?.length) {
      const matchedActivities = ACTIVITY_TYPES.filter((a) =>
        filters.ActivityTypes.includes(a.id)
      );
      setSelectedActivityTypes(matchedActivities);
    }

    setIsHydrated(true);
  }, [savedFilter?.data, assignmentGroups, fieldEngineer, customers, regions]);

  useEffect(() => {
    if (!isHydrated) return;

    const overviewPayload = {
      datePreset: overviewFilters.date?.id ?? "all",
      assignmentGroups: selectedGroups.map((g) => g.name),
      fieldEngineer: normalizeFieldEngineerPayload(),
      customers: selectedAccounts.map((c) => c.customerId),
      regions: selectedRegions.map((r) => r.name)
    };

    fetchOverview(overviewPayload);

    getSlaKpi(overviewPayload);

    getSiteNotAccessibleKpi({ ...overviewPayload, isSiteNotAccessible: true });

    fetchResponseOverview({
      datePreset: responseFilters.date?.id ?? "all",
      customers: selectedCustomers.map((c) => c.customerId),
      activityTypes: selectedActivityTypes.map((a) => a.id)
    });
  }, [isHydrated]);

  /* ---------------- Chart Data ---------------- */
  const resolutionByAssignmentGroup =
    overview?.data?.caseTaskResolutionOverview_ByAssignmentGroup || [];

  const resolutionCategories = resolutionByAssignmentGroup.map(
    (item: any) => item.AssignmentGroup
  );

  const resolutionSeries = [
    {
      name: "Within SLA",
      data: resolutionByAssignmentGroup.map((i: any) => i.NonBreached)
    },
    {
      name: "Breached",
      data: resolutionByAssignmentGroup.map((i: any) => i.Breached)
    }
  ];

  const responseByCustomer =
    responseOverview?.data?.responseOverview_ByCustomer || [];
  const responseByCustomerCategories = responseByCustomer.map(
    (item: any) => item.CustomerName
  );

  const responseByCustomerIdMap = responseByCustomer.reduce(
    (acc: Record<string, string>, item: any) => {
      acc[item.CustomerName] = item.CustomerId;
      return acc;
    },
    {}
  );

  const responseByCustomerSeries = [
    {
      name: "Within SLA",
      data: responseByCustomer.map((i: any) => i.NonBreached)
    },
    { name: "Breached", data: responseByCustomer.map((i: any) => i.Breached) }
  ];

  /* ---------------- UI ---------------- */
  return (
    <div className="px-4 pb-4 dashboard-container overflow-scroll">
      {/* ---------------- Overview Filters ---------------- */}
      <div className="flex gap-3 items-center justify-between">
        <OverviewFilters
          DATE_PRESETS={DATE_PRESETS}
          overviewFilters={overviewFilters}
          selectedGroups={selectedGroups}
          selectedFieldEngineers={selectedFieldEngineers}
          selectedAccounts={selectedAccounts}
          selectedRegions={selectedRegions}
          assignmentGroups={assignmentGroups?.data}
          fieldEngineer={fieldEngineer}
          customers={customers?.data}
          regions={regions?.data}
          setSelectedGroups={setSelectedGroups}
          setSelectedFieldEngineers={(v: any) => {
            setSelectedFieldEngineers(v);
          }}
          setSelectedAccounts={setSelectedAccounts}
          setSelectedRegions={setSelectedRegions}
          updateOverviewFilter={updateOverviewFilter}
          syncOverviewFiltersToUrl={syncOverviewFiltersToUrl}
          handleApplyOverviewFilters={handleApplyOverviewFilters}
          handleClearOverviewFilters={handleClearOverviewFilters}
        />
        <div className="flex items-center gap-2">
          <Select
            onValueChange={handleDashboardChange}
            value={selectedDashboard}
          >
            <SelectTrigger className="w-[25vw]">
              <SelectValue placeholder="Select Dashboard" />
            </SelectTrigger>
            <SelectContent className="dashboard-container">
              {dashboardOptions.map((item) => (
                <SelectItem key={item.label} value={item.label}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button
            variant="secondary"
            onClick={handleRefresh}
            title="Refresh Dashboard"
          >
            <RefreshCcw size={16} />
          </Button>
        </div>
      </div>

      {/* ---------------- Main Charts ---------------- */}
      <div className="grid gap-[0.5em] mt-[0.5em] grid-cols-6">
        <SlaKpiCard
          label="Unacknowledged"
          value={nf.format(slaKpiData?.unacknowledged || 0)}
          // Icon={FolderOpen}
          fontClass="text-7xl text-center text-[#B61C2D]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  status: "Unacknowledged",
                  title: "Unacknowledged",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />

        <SlaKpiCard
          label="Acknowledged"
          value={nf.format(slaKpiData?.acknowledged || 0)}
          // Icon={FolderCheck}
          fontClass="text-7xl text-center text-[#000000]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  status: "Acknowledged",
                  title: "Acknowledged",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />

        <SlaKpiCard
          label="Trip Started"
          value={nf.format(slaKpiData?.tripStarted || 0)}
          // Icon={FolderClock}
          fontClass="text-7xl text-center text-[#000000]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  status: "TripStarted",
                  title: "Trip Started",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />

        {/* Awaiting Confirmation — NOT yellow */}
        <SlaKpiCard
          label="Awaiting Confirmation"
          value={nf.format(slaKpiData?.awaitingConfirmation || 0)}
          // Icon={Hourglass}
          fontClass="text-7xl text-center text-[#000000]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  status: "AwaitingConfirmation",
                  title: "Awaiting Confirmation",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />

        <SlaKpiCard
          label="On Hold"
          value={nf.format(slaKpiData?.onHold || 0)}
          // Icon={FolderClockIcon}
          fontClass="text-7xl text-center text-[#000000]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  status: "OnHold",
                  title: "On Hold",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />

        <SlaKpiCard
          label="Site Not Accessible"
          value={nf.format(siteNotAccessibleKpi?.siteNotAccessible || 0)}
          // Icon={FolderX}
          fontClass="text-7xl text-center text-[#B61C2D]"
          onClick={() => {
            navigate(
              generateDetailLink({
                scope: "overview",
                params: {
                  // status: null,
                  title: "Site Not Accessible",
                  eventType: null,
                  isBreached: null,
                  isAboutToBreach: null,
                  isSiteNotAccessible: true,
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })
            );
          }}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-4">
        {/* Left: PieCharts */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4"> */}
        <Card className="bg-white shadow-md rounded-lg hover:shadow-lg transition-shadow">
          <CardContent className="p-5 cursor-pointer">
            <div className="mb-3 font-semibold text-lg text-gray-800">
              Resolution SLA Overview
            </div>
            <PieChart
              data={[
                {
                  status: "Within SLA",
                  count:
                    overview?.data
                      ?.caseTaskResolutionOverview_BreachedNonBreached
                      ?.NonBreached || 0
                },
                {
                  status: "Breached",
                  count:
                    overview?.data
                      ?.caseTaskResolutionOverview_BreachedNonBreached
                      ?.Breached || 0
                }
              ]}
              label="status"
              series="count"
              onSliceClick={({ label }) => {
                navigate(
                  generateDetailLink({
                    scope: "overview",
                    params: {
                      eventType: "Resolution",
                      title: `Resolution SLA ${label}`,
                      isBreached: label === "Breached",
                      assignmentGroup: selectedAssignmentGroupNames.join(","),
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />

            {/* Stats */}
            <div className="mt-4 flex justify-between items-center">
              <div className="bg-green-50 text-green-700 border border-green-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                Within SLA:{" "}
                {overview?.data?.caseTaskResolutionOverview_BreachedNonBreached
                  ?.NonBreached || 0}
              </div>

              <div className="bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-md shadow-sm text-sm font-medium">
                Breached:{" "}
                {overview?.data?.caseTaskResolutionOverview_BreachedNonBreached
                  ?.Breached || 0}
              </div>
            </div>
          </CardContent>
        </Card>
        {/* </div> */}

        {/* Right: ProgressBars + SemiCircle */}
        <div className="grid grid-cols-1 gap-4">
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4"> */}
          <ProgressBarChart
            title="Resolution SLA About To Breach"
            value={
              overview?.data?.caseTaskResolutionOverview_AboutToBreach
                ?.aboutToBreachCount || 0
            }
            valueString="About To Breach"
            totalString="Total"
            count={
              overview?.data?.caseTaskResolutionOverview_BreachedNonBreached
                ?.Total
            }
            filters={{
              date: overviewFilters.date,
              assignmentGroups: selectedAssignmentGroupNames,
              sourceDashboard: window.location.pathname
            }}
            eventType="Resolution"
          />
          {/* </div> */}

          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4"> */}
          <Card className="bg-white shadow-md rounded-xl hover:shadow-xl transition-shadow duration-300 pt-4">
            <Link
              to={generateDetailLink({
                scope: "overview",
                params: {
                  eventType: "Resolution",
                  status: "InProgress",
                  isBreached: true,
                  isAboutToBreach: false,
                  title: "Resolution SLA Breach In Progress",
                  assignmentGroup: selectedAssignmentGroupNames.join(","),
                  sourceDashboard: window.location.pathname
                },
                overviewFilters,
                responseFilters,
                selectedAssignmentGroupNames,
                selectedFieldEngineers,
                selectedAccounts,
                selectedRegions
              })}
            >
              <SemiCircleRadialChart
                title="Resolution SLA Breach In Progress"
                percent={
                  overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                    ?.breachInProgressPercent || 0
                }
                count={
                  overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                    ?.breachInProgressCount || 0
                }
                total={
                  overview?.data?.caseTaskResolutionOverview_Breach_InProgress
                    ?.total || 0
                }
              />
            </Link>
          </Card>
          {/* </div> */}
        </div>
      </div>

      {/* ---------------- Assignment Group & Customer Charts ---------------- */}
      <div className="grid grid-cols-2 gap-6">
        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Resolution SLA by Assignment Group
            </div>
            <MultipleStackedBarChart
              categories={resolutionCategories}
              series={resolutionSeries}
              height={350}
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "overview",
                    params: {
                      eventType: "Resolution",
                      assignmentGroup: category,
                      isBreached,
                      title: `Resolution SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>
      </div>

      {/* ---------------- Response Overview Filters ---------------- */}
      <div className="flex gap-3 items-center justify-start p-4">
        <ResponseFilters
          DATE_PRESETS={DATE_PRESETS}
          responseFilters={responseFilters}
          selectedCustomers={selectedCustomers}
          selectedActivityTypes={selectedActivityTypes}
          customers={customers?.data}
          ACTIVITY_TYPES={ACTIVITY_TYPES}
          setSelectedCustomers={setSelectedCustomers}
          setSelectedActivityTypes={setSelectedActivityTypes}
          updateResponseFilter={updateResponseFilter}
          syncResponseFiltersToUrl={syncResponseFiltersToUrl}
          handleApplyResponseFilters={handleApplyResponseFilters}
          handleClearResponseFilters={handleClearResponseFilters}
        />
      </div>

      {/* ---------------- Response SLA by Customer & Activity Type ---------------- */}
      <div className="grid grid-cols-2 gap-6">
        {/* Response SLA by Customer */}
        <Card>
          <CardContent className="p-4 cursor-pointer">
            <div className="mb-2 font-semibold text-lg">
              Response SLA by Customer
            </div>
            <MultipleStackedBarChart
              categories={responseByCustomerCategories}
              series={responseByCustomerSeries}
              horizontal
              height={350}
              onBarSliceClick={({ category, isBreached }) => {
                navigate(
                  generateDetailLink({
                    scope: "response",
                    params: {
                      eventType: "Response",
                      customerId: responseByCustomerIdMap[category],
                      isBreached,
                      title: `Response SLA - ${category}`,
                      sourceDashboard: window.location.pathname
                    },
                    overviewFilters,
                    responseFilters,
                    selectedAssignmentGroupNames,
                    selectedFieldEngineers,
                    selectedAccounts,
                    selectedRegions
                  })
                );
              }}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
